import { render } from "./ViewInfo.vue?vue&type=template&id=7f10a342&scoped=true&ts=true"
import script from "./ViewInfo.vue?vue&type=script&lang=ts"
export * from "./ViewInfo.vue?vue&type=script&lang=ts"

import "./ViewInfo.vue?vue&type=style&index=0&id=7f10a342&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f10a342"]])

export default __exports__